export const METHODS_CREATION = [
  { text: "Indefinido", value: "undefined" },
  { text: "Manual", value: "manual" },
  { text: "Automatico", value: "automatic" },
  { text: "Conversion", value: "convert" }
];

export function getMethodByValue(
  value,
  defaultValue = { text: "Indefinido", value: "undefined" }
) {
  return (
    METHODS_CREATION.find(method => method.value === value) || defaultValue
  );
}
